export default "__VITE_ASSET__NhTglhF9__"